import React, { useEffect, useState } from 'react';
import MaskReal from 'services/formateRS';

import Button from "components/CustomButtons/Button.js";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Table from "components/Table/Table.js";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import SomeSpinner from "components/Somespinner/Somespinner.js"

import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import DatePicker from "components/Datepicker/Datepicker";
import api from "assets/services/api";

const useStyles2 = makeStyles(styles2);

const styles = {
    margintp: {
        textAlign: "right",
        marginTop: "10px"
    }
};

const useStyles = makeStyles(styles);

function ModalShowStatusReportMetaImport(props) {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };
    const classes2 = useStyles2();
    const classes = useStyles();
    const { storageId, garlicType } = useAuth();

    const [br, setBR] = React.useState(false);
    const [controlSnack, setControlSnack] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (controlSnack) showNotification("br");
    }, [controlSnack]);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        };
    };

    const tableData = () => {
        let teste = [];
        for (let i = 0; i < props.data.errors.others.length; i++) {
            teste[i] = [];
            teste[i].push(props.data.errors.others[i]);


        };
        return teste;
    };
    const tableDataNf = () => {
        let teste = [];
        for (let i = 0; i < props.data.errors.nfExist.length; i++) {
            teste[i] = [];
            teste[i].push(props.data.errors.nfExist[i]);


        };
        return teste;
    };
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {`Relatorio adição vendas Meta <-> DSA`}
                </Modal.Title>
            </Modal.Header>
            <Form >
                <Modal.Body>
                    <b>Total de sucesso: {props.data.success} <br />
                        Total de erros: {props.data.errors.length}</b>
                    <div style={{ padding: '0 7em 0 7em' }}>
                        <Table
                            tableHeaderColor="danger"
                            tableHead={["Descrição"]}
                            tableData={tableData()}
                        />
                        <Table
                            tableHeaderColor="danger"
                            tableHead={["Descrição"]}
                            tableData={tableDataNf()}
                        />
                    </div>
                    {/*<div className={classes.margintp}>
                        <b>Preço total: R${totalList}<br />
                            Total de descontos: R$ {totalDiscount} <br />
                            Resultado da operação: R$ {parseFloat(totalList - totalDiscount).toFixed(2)}</b>
                    </div>*/}
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message={" lote adicionado com sucesso"}
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                    {loading ?
                        <div>
                            <SomeSpinner />
                        </div> :
                        <div></div>
                    }
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalShowStatusReportMetaImport;